<template>
  <div class="w-screen max-w-md">
    <div class="glass-carbon flex h-full flex-col overflow-y-scroll pb-24">
      <div
        class="dark:bg-ontick-carbon-500 sticky top-0 z-10 bg-gray-50 px-6 py-3 pr-14"
      >
        <div class="flex items-center space-x-4">
          <div class="h-7">
            <button
              @click="$emit('close')"
              class="py-1 text-gray-400 hover:text-gray-400 focus:outline-none"
            >
              <span v-html="$icons.arrow_left" />
            </button>
          </div>
          <h2
            class="text-ontick-carbon-900 py-3 text-lg font-semibold dark:text-gray-300"
          >
            Filtros
          </h2>
        </div>
      </div>

      <div class="space-y-8 px-6 py-3 pr-14">
        <div
          v-for="filter in getFilters"
          :key="filter.slug"
          class="space-y-2"
          :class="{ 'block md:hidden': filter.slug === 'chars' }"
        >
          <div class="flex items-center space-x-2">
            <span class="text-sm">
              {{ filter.name }}
            </span>
          </div>
          <!-- <div
            class="relative w-full overflow-hidden rounded"
            v-if="filter.type === 'string'"
          >
            <input
              type="text"
              class="dark:bg-ontick-steel-500 border-ontick-steel-300 block w-full border-2 bg-transparent dark:border-none"
              v-if="active"
              :id="'input' + filter.slug"
              @input="search({ slug: filter.slug, value: $event.target.value })"
            />
            <div
              class="dark:bg-ontick-steel-500 absolute top-0 right-0 flex h-full items-center px-2"
              v-if="fakeLoading"
            >
              <i v-html="$icons.loading" class="text-ontick-blue-600"></i>
              <span class="sr-only">Carregando busca</span>
            </div>
          </div> -->

          <div class="w-full">
            <!-- <ontick-slider-component
              v-if="filter.type === 'range'"
              :min="filter.min"
              :max="filter.max"
              :from="filter.from"
              :to="filter.to"
              :step="filter.step"
              :isCurrency="isCurrency(filter.slug)"
              :percent="['profit'].includes(filter.slug)"
              :limit="limit(filter.slug)"
              @input="setRangeFilter({ slug: filter.slug, value: $event })"
            /> -->
            <div class="flex flex-wrap gap-2" v-if="filter.type === 'tagbox'">
              <button
                v-for="item in filter.values"
                :key="item.value"
                class="max-w-min cursor-pointer whitespace-nowrap rounded px-2 py-1 text-sm"
                :class="
                  filter.active.includes(item.value)
                    ? 'bg-ontick-blue-600'
                    : 'dark:bg-ontick-steel-500 ring-ontick-steel-300 bg-transparent ring-1 dark:ring-0'
                "
                @click="setFilter({ slug: filter.slug, value: item.value })"
              >
                {{ item.name }}
              </button>
            </div>
          </div>
        </div>
        <div class="pt-6" v-if="showButton">
          <ontick-button
            class="w-full"
            customClass="border border-ontick-blue-600 text-ontick-blue-600 rounded"
            @click.native="clearActiveFilters"
          >
            Remover filtros
          </ontick-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
// import ontickSliderComponent from "../../../shared/components/basic/ontick-slider.component.vue";
export default {
  components: {
    // ontickSliderComponent,
  },

  computed: {
    ...mapGetters({
      getFilters: "longShort/filters/getFilters",
      getActiveFilters: "longShort/filters/getActiveFilters",
    }),
    showButton() {
      return !!this.getActiveFilters.length;
    },
  },

  methods: {
    ...mapActions({
      clearActiveFilters: "longShort/filters/clearActiveFilters",
      setFilter: "longShort/filters/setFilter",
    }),
  },
};
</script>
